import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Form, FormGroup, Label, Input, Button } from "reactstrap";

const LocationCard = ({ items, name, projLocationList, onValidate, projectId, activeTab }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [action, setAction] = useState("merge");
  const [selectedMergeItem, setSelectedMergeItem] = useState(null);

  useEffect(() => {
    if (items && items.length > 0) {
      setSelectedItem(items[0]);
    }
    // Set merge target to "General" or "General (Unallocated Container)"
    const defaultMergeItem = projLocationList.find(
      item => item.name === "General" || item.name === "General (Unallocated Container)"
    );
    setAction("merge");
    setSelectedMergeItem(defaultMergeItem || projLocationList[0] || null);
  }, [items, projLocationList]);

  const handleSelectionChange = (e) => {
    const locationId = e.target.value;
    const item = items.find(item => String(item.locationId) === locationId);
    if (item) {
      setSelectedItem(item);
    }
  };

  const handleMergeChange = (e) => {
    const mergeGuid = e.target.value;
    const selected = projLocationList.find(item => String(item.locationGuid) === mergeGuid);
    if (selected) {
      setSelectedMergeItem(selected);
    }
  };

  const handleValidate = () => {
    if (!selectedMergeItem) return;
    const mergeItem = {
      locationGuid: selectedMergeItem.locationGuid,
      name: selectedMergeItem.name,
      description: selectedMergeItem.description,
      isGeneric: selectedMergeItem.isGeneric,
    };
    const updatedLocations = [
      ...items.map(item => ({ ...item, uploadedBy: undefined })),
      mergeItem,
    ];
    const caseBItems = {
      BidItems: [],
      Ccos: [],
      Locations: updatedLocations,
      SelectedBidItemGuid: null,
      SelectedCcoGuid: null,
      SelectedLocationGuid: selectedMergeItem.locationGuid,
    };
    onValidate(projectId, caseBItems, activeTab);
  };

  return (
    <Card style={{ marginBottom: "1rem" }}>
      <CardBody>
        <CardTitle tag="h5">Location: {name}</CardTitle>
        <Form>
          <FormGroup>
            <Label for={`select-${name}`}>Select</Label>
            <Input
              type="select"
              id={`select-${name}`}
              value={selectedItem?.locationId || ""}
              onChange={handleSelectionChange}
            >
              {items
                .filter(item => !item.isValidated)
                .map(item => (
                  <option key={item.locationId} value={item.locationId}>
                    From {item.uploadedBy} on {new Date(item.uploadedOn).toLocaleString()}
                  </option>
                ))}
            </Input>
          </FormGroup>
          <FormGroup tag="fieldset" className="mt-4">
            <legend>Action</legend>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="action"
                  value="merge"
                  checked={action === "merge"}
                  readOnly
                />{" "}
                Merge with Existing Item
              </Label>
              <Input
                type="select"
                id={`mergeWith-${name}`}
                value={selectedMergeItem?.locationGuid || ""}
                onChange={handleMergeChange}
                disabled
              >
                {projLocationList.map(item => (
                  <option key={item.locationId} value={item.locationGuid}>
                    {item.name} - {item.description}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </FormGroup>
          <Button color="primary" onClick={handleValidate} className="mt-3" disabled={action === null}>
            Validate
          </Button>
        </Form>
      </CardBody>
    </Card>
  );
};

export default LocationCard;
